import { issueVisibility, workPhaseType } from "../enums";

export const getter = {
  getTokenBearer,
  getRoleActions,
  getWorkPhase,
  getRoleId,
  isIssueVisible,
  isActionAllowed,
};

function getTokenBearer() {
  const token = JSON.parse(localStorage.getItem("token"));
  return token?.bearer;
}

function getRoleActions(project, user) {
  if (user.id === undefined) {
    return null;
  }
  return project.actions;
}

function getWorkPhase(work) {
  const workPhase = Object.values(workPhaseType).find((w) => w.value === work);
  return workPhase.label;
}

function getRoleId(project, userId) {
  const role = project.collaboratorRoles.find(
    (r) => r.collaboratorId === userId
  );
  return role ? role.roleDefinitionId : null;
}

function isIssueVisible(issue, userId, roleId) {
  return (
    issue.creatAuthorId === userId ||
    issue.reviewerId === userId ||
    (issue.assignedCollaboratorIds &&
      issue.assignedCollaboratorIds.includes(userId)) ||
    issue.visibility === issueVisibility.PUBLIC.value ||
    (issue.visibility === issueVisibility.RESTRICTED.value &&
      issue.allowedCollaboratorGroups.includes(roleId))
  );
}

function isActionAllowed(roleActions, action) {
  const actionMap = roleActions.find((a) => a.action === action);
  if (!actionMap) return false;
  return actionMap.isAllowed;
}
